import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SessaoService } from '../../services/sessao.service';
import { AbstractComponent } from '../../util/abstract.component';

@Component({
  selector: 'app-bra-confirm',
  templateUrl: './bra-confirm.component.html',
  styleUrls: ['./bra-confirm.component.css']
})
export class BraConfirmComponent extends AbstractComponent implements OnInit {

  mensagem: string;

  constructor(
    private sessaoService: SessaoService,
    public dialogRef: MatDialogRef<BraConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    super(sessaoService);
  }

  ngOnInit() {
    this.mensagem = this.data.mensagem;
    this.dialogRef.disableClose = true;
  }

  confirmar(){
    this.dialogRef.close("Sim");
  }

  fechar() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/componentes/bra-confirm/bra-confirm.component.ts